export type DisplayCurrency = 'GBP' | 'USD';

/** AttendIn's base currency - the fallback when no ticket-specific currency is known (e.g. a price
 * preview with no selected ticket yet). Never guessed from locale/timezone - always pass a ticket's
 * own `currency` field to <CurrencyDisplay />/<CurrencyIcon /> when one is available. */
export const getDisplayCurrency = (): DisplayCurrency => {
    return 'GBP';
};

/** Narrow symbol for a ticket's own currency - matches the backend's CurrencyHelper.GetSymbol. */
export const getCurrencySymbol = (currency: 'GBP' | 'USD' | 'EUR'): string => {
    switch (currency) {
        case 'GBP': return '£';
        case 'USD': return '$';
        case 'EUR': return '€';
        default: return `${currency} `;
    }
};

/**
 * String-returning counterpart to <CurrencyDisplay /> for non-JSX contexts (alerts,
 * notifications, chart formatters, template strings). No amount conversion is ever applied.
 * Pass `currency` to format a known amount (e.g. a ticket's price) in its own currency.
 */
export const formatCurrencyAmount = (value: number, options?: Intl.NumberFormatOptions & { currency?: 'GBP' | 'USD' | 'EUR' }): string => {
    const currency = options?.currency ?? getDisplayCurrency();
    const locale = currency === 'GBP' ? 'en-GB' : 'en-US';


    return new Intl.NumberFormat(locale, {
        style: 'currency',
        currencyDisplay: 'narrowSymbol',
        ...options,
        // Re-applied after the spread - options.currency may be an explicit `undefined` (an
        // optional currency prop that wasn't resolved), which would otherwise overwrite the
        // fallback above and make Intl.NumberFormat throw for missing a currency code.
        currency,
    }).format(value);
};